// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2bnbu","detailsBorder":"styles_detailsBorder__ulsaM"};